import { render, staticRenderFns } from "./RegulationPeriod.vue?vue&type=template&id=353ee9e3&"
import script from "./RegulationPeriod.vue?vue&type=script&lang=js&"
export * from "./RegulationPeriod.vue?vue&type=script&lang=js&"
import style0 from "./RegulationPeriod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports